import {
  calculateVariation,
  calculateVariationDirection,
  type BoxDashboardKpiEntity,
  type VariationDirection,
} from "@/modules/boxDashboard/modules/KPI/entities/boxDashboardKpiEntity"

export type ActivationCountModel = {
  count: number
  comparisonCount: number | null
  variationDirection: VariationDirection | null
}

export type ActivationsKpiModel = {
  membership: ActivationCountModel
  classPass: ActivationCountModel
  dropIn: ActivationCountModel
}

export function createEmptyActivationsKpiModel(): ActivationsKpiModel {
  return {
    membership: {
      count: 0,
      comparisonCount: null,
      variationDirection: null,
    },
    classPass: {
      count: 0,
      comparisonCount: null,
      variationDirection: null,
    },
    dropIn: {
      count: 0,
      comparisonCount: null,
      variationDirection: null,
    },
  }
}

export function createActivationsKpiModel(entity: BoxDashboardKpiEntity): ActivationsKpiModel {
  const membershipFocus = entity.activations.membership.baseline
  const membershipComparison = entity.activations.membership.comparison

  const classPassFocus = entity.activations.classPass.baseline
  const classPassComparison = entity.activations.classPass.comparison

  const dropInFocus = entity.activations.dropIn.baseline
  const dropInComparison = entity.activations.dropIn.comparison

  return {
    membership: {
      count: membershipFocus,
      comparisonCount: calculateVariation(membershipFocus, membershipComparison),
      variationDirection: calculateVariationDirection(membershipFocus, membershipComparison),
    },
    classPass: {
      count: classPassFocus,
      comparisonCount: calculateVariation(classPassFocus, classPassComparison),
      variationDirection: calculateVariationDirection(classPassFocus, classPassComparison),
    },
    dropIn: {
      count: dropInFocus,
      comparisonCount: calculateVariation(dropInFocus, dropInComparison),
      variationDirection: calculateVariationDirection(dropInFocus, dropInComparison),
    },
  }
}
